export default {
  path: '/industrial_computers',
  name: 'industrial_computers',
  component: () => import('../components/industrialcomputer/Layout'),
  redirect: { name: 'IndustrialComputerList' },
  meta: {
    breadcrumb: 'industrialcomputer.industrialcomputers',
  },
  children: [
    {
      name: 'IndustrialComputerList',
      path: '',
      component: () => import('../views/industrialcomputer/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'IndustrialComputerCreate',
      path: 'new',
      component: () => import('../views/industrialcomputer/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'IndustrialComputerUpdate',
      path: ':id/edit',
      component: () => import('../views/industrialcomputer/Update'),
      meta: {
        breadcrumb: 'industrialcomputer.industrialcomputer',
      },
    },
    {
      name: 'IndustrialComputerShow',
      path: ':id',
      component: () => import('../views/industrialcomputer/Show'),
      meta: {
        breadcrumb: 'industrialcomputer.industrialcomputer',
      },
    }
  ]
};
